export default "__VITE_ASSET__DjJPvmTk__"